<template>
    <b-card no-body>
        <b-card-header class="p-2">
            <h4 class="mb-0 font-weight-bolder">
                <span>مشتریان</span>
                <feather-icon @click="$bvModal.show('modal-customers-description')" size="21" icon="HelpCircleIcon"
                    class="text-muted ml-75 pointer" />
            </h4>
            <h5 @click="$router.push(`/customers`)" class="mb-0 text-info pointer">
                گزارش جامع
            </h5>
        </b-card-header>
        <hr class="m-0">
        <div class="px-2 pt-1 pb-2">
            <div class="d-flex align-items-center mb-1 mb-md-50">
                <h4 class="mb-0">تعداد : </h4>
                <div class="d-flex align-items-center ml-25">
                    <h4 class="mb-0 font-weight-bolder">
                        {{ customerAnalytics.totalCount.toLocaleString('fa-IR') }}
                    </h4>
                    <h5 class="mb-0 ml-25">مشتری</h5>
                </div>
            </div>
            <div class="mt-2">
                <h5>همراهِ همیشگی </h5>
                <div class="d-flex align-items-center mb-75">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 font-weight-bolder">
                            {{ customerAnalytics.groups[0].count.toLocaleString('fa-IR') }}
                        </h4>
                        <h5 class="mb-0 ml-25">مشتری</h5>
                    </div>
                    <div class="d-flex align-items-center ml-25">
                        <h4 class="mb-0 font-weight-bolder">
                            {{
                                `${customerAnalytics.groups[0].percentage}`
                            }}
                        </h4>
                        <h5 class="mb-0 ml-25">درصد</h5>
                    </div>
                </div>
                <b-progress :max="max" class="progress-bar-info" style="height: 25px;border-radius: 5px;">
                    <b-progress-bar :value="customerAnalytics.groups[0].percentage"
                        :style="{ backgroundColor: '#50E3C2', borderRadius: '5px', fontSize: '16px' }" />
                </b-progress>
            </div>
            <div class="mt-2">
                <h5>همراهِ هفتگی</h5>
                <div class="d-flex align-items-center mb-75">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 font-weight-bolder">
                            {{ customerAnalytics.groups[1].count.toLocaleString('fa-IR') }}
                        </h4>
                        <h5 class="mb-0 ml-25">مشتری</h5>
                    </div>
                    <div class="d-flex align-items-center ml-25">
                        <h4 class="mb-0 font-weight-bolder">
                            {{
                                `${customerAnalytics.groups[1].percentage}`
                            }}
                        </h4>
                        <h5 class="mb-0 ml-25">درصد</h5>
                    </div>
                </div>
                <b-progress :max="max" class="progress-bar-info" style="height: 25px;border-radius: 5px;">
                    <b-progress-bar :value="customerAnalytics.groups[1].percentage"
                        :style="{ backgroundColor: '#ffd057', borderRadius: '5px', fontSize: '16px' }" />
                </b-progress>
            </div>
            <div class="mt-2">
                <h5>همراهِ ماهانه</h5>
                <div class="d-flex align-items-center mb-75">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 font-weight-bolder">
                            {{ customerAnalytics.groups[2].count.toLocaleString('fa-IR') }}
                        </h4>
                        <h5 class="mb-0 ml-25">مشتری</h5>
                    </div>
                    <div class="d-flex align-items-center ml-25">
                        <h4 class="mb-0 font-weight-bolder">
                            {{
                                `${customerAnalytics.groups[2].percentage}`
                            }}
                        </h4>
                        <h5 class="mb-0 ml-25">درصد</h5>
                    </div>
                </div>
                <b-progress :max="max" class="progress-bar-info" style="height: 25px;border-radius: 5px;">
                    <b-progress-bar :value="customerAnalytics.groups[2].percentage"
                        :style="{ backgroundColor: '#ffb446', borderRadius: '5px', fontSize: '16px' }" />
                </b-progress>
            </div>
            <div class="mt-2">
                <h5>لبه‌ی فراموشی</h5>
                <div class="d-flex align-items-center mb-75">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 font-weight-bolder">
                            {{ customerAnalytics.groups[3].count.toLocaleString('fa-IR') }}
                        </h4>
                        <h5 class="mb-0 ml-25">مشتری</h5>
                    </div>
                    <div class="d-flex align-items-center ml-25">
                        <h4 class="mb-0 font-weight-bolder">
                            {{
                                `${customerAnalytics.groups[3].percentage}`
                            }}
                        </h4>
                        <h5 class="mb-0 ml-25">درصد</h5>
                    </div>
                </div>
                <b-progress :max="max" class="progress-bar-info" style="height: 25px;border-radius: 5px;">
                    <b-progress-bar :value="customerAnalytics.groups[3].percentage"
                        :style="{ backgroundColor: '#4A90E2', borderRadius: '5px', fontSize: '16px' }" />
                </b-progress>
            </div>
            <div class="mt-2">
                <h5>مشتریان خاموش</h5>
                <div class="d-flex align-items-center mb-75">
                    <div class="d-flex align-items-center">
                        <h4 class="mb-0 font-weight-bolder">
                            {{ customerAnalytics.groups[4].count.toLocaleString('fa-IR') }}
                        </h4>
                        <h5 class="mb-0 ml-25">مشتری</h5>
                    </div>
                    <div class="d-flex align-items-center ml-25">
                        <h4 class="mb-0 font-weight-bolder">
                            {{
                                `${customerAnalytics.groups[4].percentage}`
                            }}
                        </h4>
                        <h5 class="mb-0 ml-25">درصد</h5>
                    </div>
                </div>
                <b-progress :max="max" class="progress-bar-info" style="height: 25px;border-radius: 5px;">
                    <b-progress-bar :value="customerAnalytics.groups[4].percentage"
                        :style="{ backgroundColor: '#847ad9', borderRadius: '5px', fontSize: '16px' }" />
                </b-progress>
            </div>
        </div>

        <!------------------------------- modal customers description ------------------------------->
        <b-modal id="modal-customers-description" title="مشتریان" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-75">
                <p v-for="(item, index) in description" :key="index">
                    {{ item }}
                </p>
            </div>
        </b-modal>

    </b-card>
</template>

<script>
import { BCard, BCardHeader, BProgress, BProgressBar } from 'bootstrap-vue';
export default {
    name: 'customerProgress',
    components: {
        BProgress,
        BProgressBar,
        BCardHeader,
        BCard,
    },
    props: {
        customerAnalytics: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            description: [
                'تعداد : تعداد کل مشتریان عضو شده.',
                'همراهِ همیشگی : مشتریانی که تقریباً هر روز خرید می‌کنند.',
                'همراهِ هفتگی : مشتریانی که تقریباً هفته‌ای یک‌بار خرید می‌کنند.',
                'همراهِ ماهانه : مشتریانی که تقریباً هر ماه یک یا دو بار خرید می‌کنند.',
                'لبه‌ی فراموشی : مشتریانی که تقریباً هر سه ماه یک یا دو بار خرید می‌کنند.',
                'مشتریان خاموش : مشتریانی که بیش از سه ماه است خریدی نداشته‌اند.',
            ],
            max: 100,
        }
    },
}
</script>